export const E_UNKNOWN = 'UNKNOWN';
export const E_EMAIL_TAKEN = 'EMAIL_TAKEN';
export const E_INVALID_CREDENTIALS = 'INVALID_CREDENTIALS';
